import { Gyphi } from '@/services'
import { PropsOf } from '@codeleap/types'
import { Gif as GiphyGif } from '@giphy/react-components'

export type GifProps = Partial<PropsOf<typeof GiphyGif>> & {
  id: string
}

export const Gif = ({ id, width = 200, ...props }: GifProps) => {
  const { data } = Gyphi.useGIF({ id })

  if (!data) return null

  return (
    <GiphyGif gif={data} width={width} onGifClick={(gif, e) => { e.preventDefault(), e.stopPropagation() }} {...props} />
  )
}
